import React, { ButtonHTMLAttributes, Fragment } from "react";

type ButtonFullProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  text: string;
  size?: string;
};

export const ButtonFullSecondary: React.FC<ButtonFullProps> = ({
  size = "extraLarge",
  text,
  ...props
}) => (
  <Fragment>
    <button
      {...props}
      className={`w-full rounded-md ${
        size === "small"
          ? "px-1 py-1"
          : size === "medium"
          ? "px-2 py-1"
          : size === "large"
          ? "px-3 py-1.5"
          : "px-4 py-3"
      } text-base font-medium text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50`}
    >
      {text}
    </button>
  </Fragment>
);
